import Decimal from 'decimal.js';
import { ComponentProps } from 'react';
import { MID_HEIGHT } from '@/lib/components/OrderBook/constants';
import { EmptyBids } from '@/lib/components/OrderBook/EmpteBids';
import { EmptyAsks } from '@/lib/components/OrderBook/EmptyAsks';
import { OrderBookSpread } from '@/lib/components/OrderBook/OrderBookSpread';
import { cn } from '@/lib/ui-kit/utils';

type EmptyOrderBookProps = ComponentProps<'div'>;

export const EmptyOrderBook = ({ className, ...props }: EmptyOrderBookProps) => {
  return (
    <div className={cn('flex h-full flex-col', className)} {...props}>
      <EmptyAsks />
      <OrderBookSpread
        key={'spread'}
        minAsk={Decimal(0)}
        maxBid={Decimal(0)}
        style={{ height: `${MID_HEIGHT}px` }}
      />
      <EmptyBids />
    </div>
  );
};
